const apiPrefix = '/equipment';


export const getEquipmentEndpoint = () => apiPrefix;
export const createEquipmentEndpoint = () => apiPrefix;
export const getByEquipmentEndpoint = (id: string) => `${apiPrefix}/getBy?prop=id&value=${id}`;
export const updateEquipmentEndpoint = (id: string) => `${apiPrefix}/${id}`;
export const deleteEquipmentEndpoint = (id: string) => `${apiPrefix}/${id}`;